export const MsgRenovationView = Backbone.View.extend({
  initialize: function () {
    $(document).off('click.showPopinRenovation', '.js-msgRenovation-moreInformation').on('click.showPopinRenovation', '.js-msgRenovation-moreInformation', e => {
      simpleTextPopin.open($(e.currentTarget).closest('.msgRenovationSection').find('.simpleTextPopin'));
    });
  }
});